/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import moment from 'moment';
import {ReduxDispatchActions} from 'interfaces/storeProps';
import {wsConnect, wsDisconnectRolledSockets} from 'store/action/websocket';
import {Store} from 'redux';
import {IAppStore} from 'store';

const oneHourInMilliseconds = moment.duration(1, 'hour').asMilliseconds();

export const disconnectRolledSocketTimeout = moment.duration(2, 'minutes').asMilliseconds();

export const nextEventCycleTimeout = (): number => Math.floor((Math.random() + 1) * oneHourInMilliseconds);

export const setupNewWebsocketEvent = (store: Store<IAppStore, ReduxDispatchActions>): void => {
  setTimeout(() => {
    store.dispatch(wsConnect());
    setupNewWebsocketEvent(store);
  }, nextEventCycleTimeout());
};

export const disconnectRolledSocketsEvent = (store: Store<IAppStore, ReduxDispatchActions>): void => {
  setTimeout(() => {
    store.dispatch(wsDisconnectRolledSockets());
    disconnectRolledSocketsEvent(store);
  }, disconnectRolledSocketTimeout);
};